import type { FC, SVGProps } from 'react'

export const HeartFilled: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.025 2.88123C12.7057 2.56186 12.3267 2.30851 11.9095 2.13566C11.4924 1.96281 11.0453 1.87384 10.5937 1.87384C10.1421 1.87384 9.69502 1.96281 9.27786 2.13566C8.86069 2.30851 8.48168 2.56186 8.16245 2.88123L7.49995 3.54373L6.83745 2.88123C6.19264 2.23642 5.3181 1.87417 4.4062 1.87417C3.49431 1.87417 2.61976 2.23642 1.97495 2.88123C1.33014 3.52604 0.967896 4.40059 0.967896 5.31248C0.967896 6.22438 1.33014 7.09892 1.97495 7.74373L2.63745 8.40623L7.49995 13.2687L12.3625 8.40623L13.025 7.74373C13.3443 7.42451 13.5977 7.04549 13.7705 6.62833C13.9434 6.21117 14.0323 5.76404 14.0323 5.31248C14.0323 4.86093 13.9434 4.4138 13.7705 3.99663C13.5977 3.57947 13.3443 3.20045 13.025 2.88123V2.88123Z"
      fill="currentColor"
    />
  </svg>
)
